import { PASSING_RATING } from './Constants';

export const getRatingLabel = (rating: number) =>
  rating >= PASSING_RATING ? 'Potential Fast Start' : 'Average Start Up';
